import { Button } from 'components/Button';
import { TutorCreditCardForm } from 'components/Forms/TutorForm/CreditCardForm';
import { useTutorUserPlan } from 'context';
import React from 'react';

import { Grid } from '@mui/material';
import { TutorAddressForm } from 'components/Forms/TutorForm/AddressForm';
import { BillingAddressForm } from 'components/Forms/TutorForm/BillingAddressForm';

interface Props {}

export const TutorContractPlanCreditCard: React.FC<Props> = ({ children }) => {
  const { finish, loading, pjBankCreditCardInputRef, handleNext } = useTutorUserPlan();

  return (
    <Grid p={2} spacing={2}>
      <TutorCreditCardForm
        disabled={loading}
        inputRef={pjBankCreditCardInputRef}
      />

      <Grid
        mt={6}
        xs={12}
        item
        container
        justifyContent="flex-end"
        alignItems="flex-end"
        spacing={2}
      >
        {/*  <Grid item>
          <Button onClick={handlePrevious} disabled={loading}>
            VOLTAR
          </Button>
        </Grid> */}

        <Grid item>
          <Button onClick={handleNext} disabled={loading} loading={loading}>
            Avançar
          </Button>
        </Grid>

        {children}
      </Grid>
    </Grid>
  );
};
